import { makeStyles, ThemeProvider } from "@material-ui/styles";
import React from "react";
import { Chart } from "react-chartjs-2";
import { Router } from "react-router-dom";
import validate from "validate.js";

import {
  Button,
  CardHeader,
  CircularProgress,
  Divider,
  Grid,
  Modal,
  Snackbar,
  Typography,
} from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import { RTL } from "components";
import "react-perfect-scrollbar/dist/css/styles.css";
import { useDispatch, useSelector } from "react-redux";
import {
  Loading,
  showModalCondition,
  showModalPassword,
  showSnackbar,
} from "redux/Action";
import "./assets/scss/index.scss";
import validators from "./common/validators";
import { chartjs } from "./helpers";
import Routes from "./Routes";
import theme from "./theme";

import clsx from "clsx";

import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

import SaveIcon from "@material-ui/icons/Save";

import MuiAlert from "@material-ui/lab/Alert";
import { axios } from "./axios";

Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw,
});

validate.validators = {
  ...validate.validators,
  ...validators,
};

const useStyles = makeStyles((themes) => ({
  imageContainer: {
    width: 140,
    height: 140,
    margin: "auto",
    position: "relative",
    overflow: "unset",
  },
  imageButton: {
    position: "absolute",
    left: -15,
    bottom: -10,
  },
  image: {
    width: 110,
    height: 110,
  },
  input: {
    // marginTop: themes.spacing(4),
    marginTop: 20,
    width: "100%",
  },
  inputBtn: {
    // marginTop: themes.spacing(3),
    marginTop: 20,

    width: "100%",
  },
  imageInput: {
    display: "none",
  },
  divider: {
    opacity: "0.1",
    marginLeft: "25%",
    marginRight: "25%",
    width: "50%",
    alignItems: "center",
    marginBottom: 15,
    backgroundColor: "#273c75",
    height: 1,
  },
  submitButtonIcon: {
    marginLeft: 10,
    // marginLeft: themes.spacing(2),
  },
  wrapper: {
    position: "relative",
    width: "100%",
  },

  buttonProgress: {
    color: "#121E3E",
    position: "absolute",
    top: "50%",
    left: "50%",
    marginLeft: -12,
  },
}));
const App = (props) => {
  const { history } = props;
  const dispatch = useDispatch();

  const snackbars = useSelector((state) => state.showSnack);
  const token = useSelector((state) => state.token);

  const ModalPass = useSelector((state) => state.showModal);
  const ModalCondition = useSelector((state) => state.showModalCondition);

  const classes = useStyles();

  const [values, setValues] = React.useState({
    showPassword: false,
    showPasswordNew: false,
    showPasswordRepeat: false,

    password: "",
    passwordNew: "",
    passwordRepeat: "",
  });

  const [error, setError] = React.useState({
    password: "",
    passwordNew: "",
    passwordRepeat: "",
  });

  const handleChange = (e) => {
    const titles = e.target.name;
    setValues({ ...values, [titles]: e.target.value });
    setError({ ...error, [titles]: "" });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleClickShowNewPassword = () => {
    setValues({ ...values, showPasswordNew: !values.showPasswordNew });
  };

  const handleClickShowRepeatPassword = () => {
    setValues({ ...values, showPasswordRepeat: !values.showPasswordRepeat });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  }; // const isLoading = useSelector(state=>state.isLoading);

  const isLoading = useSelector((state) => state.isLoading);

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const SendChangePass = async () => {
    try {
      const res = await axios.post(
        `resetPassword`,
        {
          old_password: values.password,
          password_confirmation: values.passwordRepeat,
          password: values.passwordNew,
        },
        {
          headers: headers,
        }
      );

      dispatch(showSnackbar(true, "success", res.data.message));
      dispatch(Loading());
      dispatch(showModalPassword(true));
      dispatch(showModalCondition(false));
    } catch (e) {
      dispatch(Loading());
      // console.log(e.response, "eeeeeeeee");
    }
  };

  const sendBtn = () => {
    let va_keys = Object.keys(values);

    let obj_empty = {};
    va_keys.forEach((element) => {
      if (values[element] === "") {
        obj_empty[element] = "این فیلد نمی تواند خالی باشد";
      }
    });

    if (values.passwordNew != values.passwordRepeat) {
      obj_empty["passwordRepeat"] = "کلمات عبور یکسان نیستند";
    }

    setError(obj_empty);

    if (Object.keys(obj_empty).length == 0) {
      SendChangePass();
      dispatch(Loading());
    } else {
      //  alert(JSON.stringify(obj_empty))
    }
  };
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router history={history}>
        <Routes />
      </Router>
      <RTL>
        <Snackbar
          open={snackbars.snackbar.show}
          autoHideDuration={5000}
          onClose={() => dispatch(showSnackbar(false))}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            style={{ minWidth: "100%" }}
            onClose={() => dispatch(showSnackbar(false))}
            severity={snackbars.snackbar.severity}
          >
            {snackbars.snackbar.text}
          </MuiAlert>
        </Snackbar>
      </RTL>

      <Modal
        open={ModalPass.modalPass.show}
        style={{
          Height: "100vh",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        onClose={() => dispatch(showModalPassword(false))}
      >
        <div
          style={{
            backgroundColor: "white",
            padding: "2%",
            width: "40%",
            border: "none",
          }}
        >
          <Grid justify="center" container>
            <CardHeader title="تغییر کلمه عبور" />
            <Divider className={classes.divider} variant="fullWidth" />
          </Grid>
          <RTL>
            <Grid container justify="space-between">
              <Grid item xs={12} sm={12}>
                <FormControl className={classes.input} variant="outlined">
                  <InputLabel htmlFor="outlined-adornment-password">
                    کلمه عبور قدیم
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type={values.showPassword ? "text" : "password"}
                    name="password"
                    error={Boolean(error?.password)}
                    value={values.password}
                    onChange={(e) => handleChange(e)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {values.showPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    labelWidth={80}
                  />
                  <Typography style={{ color: "red" }}>
                    {error?.password}
                  </Typography>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container justify="space-between">
              <Grid item xs={12} sm={12}>
                <FormControl className={clsx(classes.input)} variant="outlined">
                  <InputLabel htmlFor="outlined-adornment-password">
                    کلمه عبور جدید
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type={values.showPasswordNew ? "text" : "password"}
                    name="passwordNew"
                    error={Boolean(error?.passwordNew)}
                    helperText={error?.passwordNew}
                    value={values.passwordNew}
                    error={Boolean(error?.passwordNew)}
                    onChange={(e) => handleChange(e)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowNewPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {values.showPasswordNew ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    labelWidth={90}
                  />
                  <Typography style={{ color: "red" }}>
                    {error?.passwordNew}
                  </Typography>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container justify="space-between">
              <Grid item xs={12} sm={12}>
                <FormControl className={clsx(classes.input)} variant="outlined">
                  <InputLabel htmlFor="outlined-adornment-password">
                    تکرار کلمه عبور جدید
                  </InputLabel>

                  <OutlinedInput
                    id="outlined-adornment-password"
                    type={values.showPasswordRepeat ? "text" : "password"}
                    name="passwordRepeat"
                    error={Boolean(error?.passwordRepeat)}
                    value={values.passwordRepeat}
                    onChange={(e) => handleChange(e)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowRepeatPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {values.showPasswordRepeat ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    labelWidth={110}
                  />
                  <Typography style={{ color: "red" }}>
                    {error?.passwordRepeat}
                  </Typography>
                </FormControl>
              </Grid>
            </Grid>
          </RTL>
          <div className={classes.wrapper}>
            <Button
              fullWidth
              className={(classes.input, classes.inputBtn)}
              variant="contained"
              color="secondary"
              size="large"
              disabled={isLoading}
              onClick={() => sendBtn()}
              startIcon={<SaveIcon className={classes.submitButtonIcon} />}
            >
              اعمال تغییرات
            </Button>
            {isLoading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
        </div>
      </Modal>

      <Modal
        open={ModalCondition.modalCondition.show}
        style={{
          // Height: 300,
          // width: "100%",
          // display: "flex",
          // justifyContent: "center",
          // alignItems: "center",
          position: "absolute",
          top: "10%",
          left: "10%",
          right: "10%",
          bottom: "10%",
          overflow: "scroll",
          height: "100%",
          display: "block",
        }}
        onClose={() => dispatch(showModalCondition(false))}
      >
        <div
          style={{
            backgroundColor: "white",
            padding: "2%",
            width: "100%",
            border: "none",
          }}
        >
          <Grid justify="center" container>
            <CardHeader
              title="قوانین و مقررات"
              titleTypographyProps={{ variant: "h3" }}
            />
            <Divider className={classes.divider} variant="fullWidth" />
          </Grid>
          <RTL>
            <Grid container style={{ marginTop: 10 }}>
              <Typography>
                کاربرانی که تمایل به ثبت بار در سیستم آنلاین بار دارند با ثبت
                نام در حساب کاربری آنلاین بار می‌پذیرند که تمامی قوانین و مقررات
                استفاده از برنامه را به طور کامل مطالعه وقبول کرده است {<br />}
                این قوانین ممکن است در طول توسعه برنامه تغییر کند که استفاده
                مستمر از آنلاین بار به معنی پذیرش هرگونه تغییر درقوانین و مقررات
                است
                {<br />}
                ثبت کنندگان بار میپذیرند که اطلاعات خواسته شده درحساب کاربری را
                بصورت صحیح و بروز در برنامه آنلاین بار وارد کند
                {<br />}
                هر حساب کاربری ثبت کننده بار روی یک شماره تماس میباشد و نمیتوان
                با آن شماره حساب کاربری جدیدی ساخت
                {<br />}
                مسئولیت همه فعالیت هایی که از طریق حساب کاربری ثبت کننده بار در
                آنلاین بار انجام میشود به عهده آن شخص یا شرکت می باشد
                {<br />}
                کاربر ثبت کننده موظف است در صورت داشتن بار نامتعارف،هرگونه پرنده
                یا حیوانات دیگر یا هر موردی از این قبیل موضوع را از قبل درقسمت
                توضیحات اعلام کند در غیر اینصورت راننده پس از تایید بار میتواند
                یکطرفه مجاز به لغو حمل بار باشد و تمامی مسئولیت خسارت بار بر
                عهده شرکت باربری و کارمند می باشد
                {<br />}
                کاربر ثبت کننده میپذیرد حداکثر بار مجاز درهر ماشین همان است که
                در کارت ماشین نوشته شده و زدن اضافه بار به‌هیچ وجه حتی با توافق
                راننده مجاز نمی باشد
              </Typography>
            </Grid>

            <Grid justify="center" container style={{ marginTop: 15 }}>
              <CardHeader
                title="تعاریف مختصر"
                titleTypographyProps={{ variant: "h3" }}
              />
              <Divider className={classes.divider} variant="fullWidth" />
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Typography>
                باربری : ارائه دهنده سرویس های بار
                {<br />}
                کاربر ثبت کننده : شخص حقیقی یا حقوقی که توسط شرکت باربری به
                عنوان کارمند می باشد و بارهای بروز شرکت را ثبت می کند.
                {<br />}
                راننده: اشخاصی که دربرنامه آنلاین بار به منظور حمل بار فعال می
                باشند.
                {<br />}
                بار: محموله ای که قرار است توسط راننده و به درخواست کاربر ثبت
                کننده به مقصد ارسال گردد.
                {<br />}
                پروفایل : حساب کاربری می باشد که رانندگان جهت استفاده از خدمات
                آنلاین بار در آنجا ثبت نام میکنند .
              </Typography>
            </Grid>

            <Grid justify="center" container style={{ marginTop: 15 }}>
              <CardHeader
                title="حریم خصوصی"
                titleTypographyProps={{ variant: "h3" }}
              />
              <Divider className={classes.divider} variant="fullWidth" />
            </Grid>

            <Grid container style={{ marginTop: 10 }}>
              <Typography>
                رعایت حریم شخصی رانندگان و کاربران ثبت کننده بار برای آنلاین بار
                دارای اهمیت بسیار زیادی می باشد نحوه ذخیره سازی و استفاده از
                اطلاعات رانندگان در سامانه آنلاین بار به شرح ذیل می باشد:
                {<br />}
                {<br />}
                در مرحله اول نیاز به تکمیل شماره تماس و …. داریم که کلیه آن
                اطلاعات دریافتی در مختصرترین شکل ممکن تنظیم گردیده است و این
                اطلاعات به هیچ عنوان در دسترس عموم قرار نخواهد گرفت.
                {<br />}
                یکی از سیاست های ما حفاظت از اطلاعاتی است که به ما داده شده است
                ما شما رو تشویق میکنیم تا خط مشی ما رابررسی کنید وبا آن آشنا
                شوید و این اطمینان خاطر رابه شما میدهیم که سامانه آنلاین بار
                اجازه استفاده از اطلاعات شخصیتان رابه اشخاص ثالث نمی دهد.
                {<br />}
                {<br />}
                قانون حفاظت از اطلاعات :{<br />}
                آنلاین بار اطلاعات رانندگان و کاربران ثبت کننده بار خود را
                دراختیار هیچ شخص و ارگانی قرار نمی دهد بجز شرکت های باربری که با
                آنلاین بار قرارداد معتبر دارند و به انجام مفاد مورد تفاهم با
                آنلاین بار مقید اند . این شرکت ها هیچ حق مستقلی برای ارائه و به
                اشتراک گذاشتن این اطلاعات ندارند.
                {<br />}
                {<br />}
                پذیرش شرایط :{<br />}
                هنگامی شما در پروفایل کاربری آنلاین بار ثبت نام میکنید شما باید
                تمامی قوانین و مقررات آنلاین بار را مطالعه کنید و بپذیرد و
                درصورتی که با بخشی از آن مخالف هستید ما قادر به همکاری با شما
                نیستیم
                {<br />}
                شما تنها زمانی میتوانید از خدمات آنلاین بار استفاده کنید که
                تمامی قوانین و مقررات ما را پذیرفته باشید .
              </Typography>
            </Grid>
          </RTL>
        </div>
      </Modal>
    </ThemeProvider>
  );
};
export default App;
